export default "__VITE_ASSET__CCNicY6J__"